import { Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { repeatEndItemList } from '.';
import FuelAutoComplete from '../../fuel-autocomplete';
import RepeatEnd from './RepeatEnd';

const Daily = ({ form, onFormChange }) => {



  useEffect(() => {
    const rrule = form.getValues('rrule');
    if (rrule && rrule.until) {
      form.setValue('rrule.until', rrule.until);
    } else if (rrule && rrule.count) {
      form.setValue('rrule.count', rrule.count);
    }
  }, [form]);

  return (
    <>
     
       <RepeatEnd form={form} onFormChange={onFormChange}/>
      <Grid item xs={4}></Grid>
    </>
  );
};

export default Daily;
